import { render, staticRenderFns } from "./manage-tree.vue?vue&type=template&id=2f86168d&scoped=true"
import script from "./manage-tree.vue?vue&type=script&lang=ts"
export * from "./manage-tree.vue?vue&type=script&lang=ts"
import style0 from "./manage-tree.vue?vue&type=style&index=0&id=2f86168d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86168d",
  null
  
)

export default component.exports